import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Spin } from 'antd'; // For loading state

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, role, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Show a loading spinner while checking auth status
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <Spin size="large" />
        </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page, saving the intended location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check roles if allowedRoles are specified
  if (allowedRoles && !allowedRoles.includes(role)) {
    // Redirect to an unauthorized page or dashboard home
    return <Navigate to="/unauthorized" replace />;
  }

  // User is authenticated and has the required role (if specified)
  return children;
};

export default ProtectedRoute;